<template>

 

  <div id="app" >
      <iframe v-if="show_iframe" :src="iframe_url" frameborder="0" style="width:100%;height:100%"></iframe>
      <div class="record_all" style="position:absolute;right:0">
          <div class="record"
         v-if="isSupported">
      <!-- <h2>Record</h2>
      <span class="rec"
            v-show="showREC">REC</span>
      <video ref="screen-share"
             autoplay /> -->
      <div class="action-group">
        <button @click="openScreenShare"
                :disabled="disabled.open">开启屏幕共享</button>
        <button :disabled="disabled.start"
                @click="start">开始录制</button>
        <!-- <button :disabled="disabled.pause"
                @click="pause">暂停</button> -->
        <!-- <button :disabled="disabled.resume"
                @click="resume">重新录制</button> -->
        <button :disabled="disabled.stop"
                @click="stop">结束</button>
        <button
        @click="close_canvas">退出</button>
      </div>
    </div>
    <!-- <h2 v-else>Sorry! WebRTC is not fully supported on your browser! Please install latest Chrome on your computer and try this page again.</h2>
    <div class="preview"
         v-if="!!blobUrl">
      <h2>Preview</h2>
      <video :src="blobUrl"
             autoplay
             controls></video>
      <button @click="handleDownload"
              class="download-button">下载</button>
    </div> -->
      </div>
    
   
  </div>
</template>

<script>
import screenfull from "screenfull";  //引入依赖
import { RECORD_STATUS_UNSTART, RECORD_STATUS_RECORDING, RECORD_STATUS_PAUSED, RECORD_STATUS_STOPPED } from '../../utils/const';
import { isScreenShareSupported, isWebRTCSupported } from '../../utils/index';

export default {
  name: 'App',
  data () {
    return {
      file_name:'',
      chunkNumber:0,
      is_last:0,
      show_iframe:false,
      iframe_url:'',
      recorder: null,
      screenShareVideoElement: null,
      localScreenShareStream: null,
      disabled: {
        open: false,
        start: true,
        pause: true,
        resume: true,
        stop: true,
      },
      status: RECORD_STATUS_UNSTART,
      chunks: [],
      blobUrl: '',
    }
  },
  computed: {
    showREC () {
      return this.status === RECORD_STATUS_RECORDING;
    },
    isSupported () {
      return isScreenShareSupported() && isWebRTCSupported();
    }
  },
  mounted () {
    window.close_canvas=this.close_canvas
      //打开画板先
      
      let formdata={
    
          topics: '',
          prepare_lessons: 'prepare_lessons',
          tocanvas_roomId: 1,
          keyValue:sessionStorage.keyValue,
          userInfo:sessionStorage.userInfo,
          token:sessionStorage.token,
          
      }
      this.axios
            .post( '/teacher/index/addotherdata', {jsondata:JSON.stringify(formdata)})
            .then((res) => {
              if (res.data.code == 1) {
                  // screenfull.toggle()
                  this.show_iframe=true
                  this.iframe_url=JSON.parse(sessionStorage.userInfo).school.server_url+ '/myCanvas/online/myCanvas.html?wss_timestamp=' + Date.parse(new Date()) + '&id=' + res.data.data;
                    
              }
            })

    this.screenShareVideoElement = this.$refs['screen-share'];
  },
  methods: {
    close_canvas(){
      // console.log('22222222222223')
      this.$router.push('/resource')
      // return
      screenfull.toggle()
      
      
    },
    async openScreenShare () {
      // alert(1)
      // const tempStream = await navigator.mediaDevices.getUserMedia({ audio: true });    //没麦暂时关
      this.localScreenShareStream = await navigator.mediaDevices.getDisplayMedia();

      // add audio track to screen share stream 
      // this.localScreenShareStream.addTrack(tempStream.getAudioTracks()[0]);    //没麦暂时关

      // do something when user stop screen share manually
      const screenShareTrack = this.localScreenShareStream.getVideoTracks()[0];
      if (screenShareTrack) {
        screenShareTrack.onended = this.onScreenShareEnded;
        screenShareTrack.onmute = this.onScreenShareEnded;
      }

      // init recorder
      this.recorder = new MediaRecorder(this.localScreenShareStream,{videoBitsPerSecond:300,audioBitsPerSecond:64,bitsPerSecond:300});
        // this.recorder.setVideoEncodingBitrate(150000); //设置比特率大小
      // this.recorder.setVideoFrameRate(20);// 帧率 
      this.recorder.onstop = this.onRecordStopped;
      this.recorder.ondataavailable = this.onDataAvailable;
    

      // this.screenShareVideoElement.srcObject = this.localScreenShareStream;
      // this.screenShareVideoElement.muted = true; // mute local audio to prevent aftersound

      this.disabled.open = true;
      this.disabled.start = false;
    },
    start () {
      let that=this
      let formdata={
    
          topics: '',
          prepare_lessons: 'prepare_lessons',
          tocanvas_roomId: 1,
          keyValue:sessionStorage.keyValue,
          userInfo:sessionStorage.userInfo,
          token:sessionStorage.token,
          
      }
      this.axios
            .post( '/teacher/index/addotherdata', {jsondata:JSON.stringify(formdata)})
            .then((res) => {
              if (res.data.code == 1) {
                  screenfull.toggle()
                  this.show_iframe=true
                  this.iframe_url=JSON.parse(sessionStorage.userInfo).school.server_url+ '/myCanvas/online/myCanvas.html?wss_timestamp=' + Date.parse(new Date()) + '&id=' + res.data.data;
                   setTimeout(function(){
                     that.recorder.start(5000);
                      that.is_last=0
                      that.chunkNumber=0
                      that.file_name=Date.parse(new Date())
                      that.status = RECORD_STATUS_RECORDING;
                      that.disabled.start = true;
                      that.disabled.pause = false;
                      that.disabled.stop = false;
                  },500)
              }
            })
      
    },
    pause () {
      this.recorder.pause();
      this.status = RECORD_STATUS_PAUSED;
      this.disabled.pause = true;
      this.disabled.resume = false;
    },
    resume () {
      this.recorder.resume();
      this.status = RECORD_STATUS_RECORDING;
      this.disabled.pause = false;
      this.disabled.resume = true;
    },
    stop () {
      this.is_last=1
      if (this.recorder.state !== 'inactive') {
        this.recorder.stop();
      }
      this.status = RECORD_STATUS_STOPPED;
      this.disabled.start = false;
      this.disabled.pause = true;
      this.disabled.resume = true;
      this.disabled.stop = true;
    },
    onDataAvailable (e) {
      console.log(111)
      console.log(e)
      this.chunkNumber++
      this.chunks.push(e.data);
      let blob = new Blob(this.chunks, { 'type': 'video/mp4' });
       let formdata=new FormData()
      formdata.append('file',new window.File([blob],  this.file_name, {type: 'video/mp4'}))
      formdata.append('chunkNumber',this.chunkNumber) 
      formdata.append('name',this.file_name) 
      if(this.is_last){
        formdata.append('is_end',1)
      }
         this.axios
            .post( '/school/tiku_video/zoneUpload', formdata)
            .then((res) => {
              if (res.data.code == 1) {
                  
                    
              }
            })


    },
    onRecordStopped () {
      const blob = new Blob(this.chunks, { 'type': 'video/mp4' });
      this.blobUrl = URL.createObjectURL(blob);
//       let files = new window.File([blob], 'aaaa', {type: 'video/mp4'})
//       let formdata=new FormData()
//       formdata.append('file',files)
//       formdata.append('file',files)
//          this.axios
//             .post( '/school/common/upload22', formdata)
//             .then((res) => {
//               if (res.data.code == 1) {
                  
//                     
//               }
//             })

  
      this.chunks = [];
    },
    onScreenShareEnded () {
      if (this.localScreenShareStream === null) {
        return;
      }
      console.log('screen share ended')
      this.stop();
      this.localScreenShareStream = null;
      // this.screenShareVideoElement.srcObject = null;

      this.disabled.open = false;
      this.disabled.start = true;
    },
    handleDownload () {
      const link = document.createElement('a');
      link.href = this.blobUrl;
      link.download = 'screen-share-record.mp4';
      link.click();
      URL.revokeObjectURL(this.blobUrl);
      this.blobUrl = '';
    }
  }
}
</script>

<style scoped>
#app {
    height: 100vh;
  /* display: flex;
  justify-content: center;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; */
  /* margin-top: 60px; */
  /* padding: 0;
  margin: 0;
  position: relative; */
}

.record_all{
    position: absolute;
    top: 0;
}
video {
  width: 500px;
  background-color: #2c3e50;
}

.rec {
  position: absolute;
  background: red;
  color: #fff;
  padding: 0 4px;
}

.preview {
  margin-left: 24px;
}

.download-button {
  display: block;
  margin: 0 auto;
}

.feedback {
  position: absolute;
  right: -123px;
  top: 20px;
  width: 300px;
  padding: 4px 8px;
  font-weight: bold;
  background: aquamarine;
  color: black;
  transform: rotate(45deg);
  text-decoration: none;
}

.box{
  width: 234px;
  padding: 0 10px;
  height: 800px;
  display: flex;
  overflow: auto;
  background: wheat;
  flex-wrap: wrap;
}
.box_item{
  width: 90px;
  height: 90px;
  background: red;
  margin: 10px;
  text-align: center;
  line-height: 90px;
  font-size: 32px;
  color: white;
}
.box_item3{
  width: 190px;
  height: 90px;
  background: red;
  margin: 10px;
  text-align: center;
  line-height: 90px;
  font-size: 32px;
  color: white;
}
.box2{
  width: 221px;
  padding: 0 10px;
  height: 800px;
  display: flex;
  overflow: auto;
  background: wheat;
  flex-wrap: wrap-reverse;
  margin-left: 200px;
  
}
.box3{
  width: 220px;
  padding: 0 10px;
  height: 800px;
  display: flex;
  overflow: auto;
  background: wheat;
  flex-direction: column-reverse;
  margin-left: 200px;
  
}
.box4{
  width: 234px;
  padding: 0 10px;
  height: 800px;
  display: flex;
  overflow: auto;
  background: wheat;
  flex-wrap: wrap;
  margin-left: 200px;
   justify-content:flex-end
}



</style>
